export default __webpack_public_path__ + "static/3p9-component-library-0394b7a5b465890c2ab577074a87ce72.png";